export const equipmentTypes = [
  { key: 'computer', value: 'COMPUTER', text: 'Computadora' },
  { key: 'server', value: 'SERVER', text: 'Servidor' },
  { key: 'storage', value: 'STORAGE', text: 'Almacenamiento / NAS' },
  { key: 'kvm', value: 'KVM', text: 'Conmutador KVM' },
  { key: 'router', value: 'ROUTER', text: 'Router' },
  { key: 'switch', value: 'SWITCH', text: 'Switch' },
  { key: 'firewall', value: 'FIREWALL', text: 'Firewall' },
  { key: 'olt', value: 'OLT', text: 'OLT' },
  { key: 'edfa', value: 'EDFA', text: 'EDFA' },
  { key: 'access_point', value: 'ACCESS_POINT', text: 'Punto de Acceso' },
  { key: 'antenna', value: 'ANTENNA', text: 'Antena' },
  { key: 'telecom', value: 'TELECOM', text: 'Equipo de Telecomunicaciones' },
  { key: 'ups', value: 'UPS', text: 'UPS / Fuente de Poder' },
  { key: 'pdu', value: 'PDU', text: 'Distribuidor de Energía (PDU)' },
  { key: 'generator', value: 'GENERATOR', text: 'Generador Eléctrico' },
  { key: 'battery', value: 'BATTERY', text: 'Batería / Banco de Energía' },
  { key: 'ac', value: 'AIR_CONDITIONER', text: 'Aire Acondicionado' },
  { key: 'fan', value: 'FAN', text: 'Ventilador / Extractor' },
  { key: 'camera', value: 'CAMERA', text: 'Cámara de Seguridad' },
  { key: 'sensor', value: 'SENSOR', text: 'Sensor Ambiental' },
  { key: 'alarm', value: 'ALARM', text: 'Alarma' },
  { key: 'access_control', value: 'ACCESS_CONTROL', text: 'Control de Acceso' },
  { key: 'printer', value: 'PRINTER', text: 'Impresora' },
  { key: 'scanner', value: 'SCANNER', text: 'Escáner' },
  { key: 'rgb', value: 'RGB', text: 'RGB / Iluminación' },
  { key: 'rack', value: 'RACK', text: 'Rack / Gabinete' },
  { key: 'monitor', value: 'MONITOR', text: 'Monitor' },
  { key: 'keyboard', value: 'KEYBOARD', text: 'Teclado' },
  { key: 'mouse', value: 'MOUSE', text: 'Ratón' },
  { key: 'other', value: 'OTHER', text: 'Otro' },
];

export const getEquipmentTypeText = (equipmentType) => {
  const found = equipmentTypes.find(type => type.value === equipmentType)
  return found ? found.text : equipmentType
}

export const styles = {
  pageContainer: {
    background: '#f8fafc',
    minHeight: '100vh',
    padding: '2rem 0'
  },
  headerCard: {
    background: 'white',
    border: 'none',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    marginBottom: '2rem',
    overflow: 'hidden'
  },
  headerGradient: {
    background: 'white',
    padding: '2rem',
    color: '#3b82f6'
  },
  sectionCard: {
    background: 'white',
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    marginBottom: '1.5rem',
    overflow: 'visible',
    height: '100%',
    position: 'relative'
  },
  sectionHeader: {
    background: 'linear-gradient(135deg, #f6f8fb 0%, #e9ecef 100%)',
    padding: '0.75rem 1.25rem',
    borderBottom: '2px solid #e0e7ff',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    minHeight: '60px'
  },
  iconBox: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem'
  },
  buttonPrimary: {
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    padding: '14px 32px',
    fontSize: '1rem',
    fontWeight: '600',
    minWidth: '160px',
    transition: 'all 0.3s ease',
    cursor: 'pointer'
  },
  buttonSecondary: {
    background: 'white',
    color: '#4a5568',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    padding: '14px 32px',
    fontSize: '1rem',
    fontWeight: '600',
    minWidth: '160px',
    transition: 'all 0.3s ease',
    cursor: 'pointer'
  },
  dropdownContainer: {
    position: 'relative'
  }
}

export const EquipmentProfileStyles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
  },
  header: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e2e8f0',
    padding: '24px 24px 16px 24px',
    marginBottom: '24px',
    minHeight: '250px',
  },
  headerTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '0',
  },
  headerContent: {
    display: 'flex',
    gap: '24px',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
  },
  photoSection: {
    width: '25%',
    minWidth: '250px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },
  photoContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },
  imageWrapper: {
    position: 'relative',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    borderRadius: '12px',
    overflow: 'hidden',
    width: '100%',
    height: '200px',
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  expandIcon: {
    color: 'white',
    fontSize: '2rem',
    marginBottom: '8px',
  },
  overlayText: {
    color: 'white',
    fontSize: '0.875rem',
    fontWeight: '500',
  },
  equipmentImage: {
    width: '100%',
    height: '200px',
    objectFit: 'cover',
    borderRadius: '12px',
    border: '3px solid #e2e8f0',
    transition: 'transform 0.3s ease',
  },
  changePhotoButton: {
    width: '100%',
    fontSize: '0.875rem',
    padding: '8px 16px',
  },
  headerInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '12px',
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.875rem',
    marginTop: '0',
    paddingTop: '0',
  },
  breadcrumbIcon: {
    color: '#3b82f6',
    marginRight: '8px',
  },
  breadcrumbText: {
    color: '#64748b',
  },
  breadcrumbSeparator: {
    color: '#cbd5e1',
    margin: '0 8px',
  },
  breadcrumbCurrent: {
    color: '#1e293b',
    fontWeight: '500',
  },
  titleSection: {
    marginBottom: '0',
  },
  title: {
    color: '#1e293b',
    fontSize: '2.25rem',
    fontWeight: '700',
    margin: '0 0 8px 0',
    letterSpacing: '-0.02em',
    lineHeight: '1.2',
  },
  badges: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '0',
  },
  assetBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 16px',
    backgroundColor: '#eff6ff',
    color: '#1e40af',
    borderRadius: '8px',
    fontSize: '0.875rem',
    fontWeight: '500',
    border: '1px solid #dbeafe',
  },
  headerActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '0',
    marginBottom: '15px',
    paddingTop: '0',
    alignItems: 'center',
  },
  editButton: {
    backgroundColor: '#3b82f6',
    color: 'white',
    padding: '12px 28px',
    borderRadius: '8px',
    border: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '0.875rem',
  },
  statsRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
    padding: '16px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    marginTop: '12px',
  },
  statItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  statIcon: {
    color: '#3b82f6',
    fontSize: '1.25rem',
    margin: 0,
  },
  statContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  statLabel: {
    fontSize: '0.7rem',
    color: '#64748b',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  statValue: {
    fontSize: '0.875rem',
    color: '#1e293b',
    fontWeight: '600',
    marginTop: '2px',
  },
  mainContent: {
    padding: '0 24px',
  },
  tabsContainer: {
    width: '100%',
    margin: '0 auto',
  },
  tabs: {
    border: 'none',
  },
  tabPane: {
    border: 'none',
    padding: '24px 0',
  },
  infoCard: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #e2e8f0',
    marginBottom: '20px',
    transition: 'all 0.2s ease',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '20px',
    paddingBottom: '16px',
    borderBottom: '2px solid #f1f5f9',
  },
  cardIcon: {
    color: '#3b82f6',
    fontSize: '1.25rem',
    margin: 0,
  },
  cardTitle: {
    color: '#1e293b',
    fontSize: '1.125rem',
    fontWeight: '600',
    margin: 0,
  },
  cardContent: {
    padding: '4px 0',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '24px',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  infoLabel: {
    fontSize: '0.875rem',
    color: '#64748b',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  infoValue: {
    fontSize: '1rem',
    color: '#1e293b',
    fontWeight: '500',
  },
  specsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  specItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid #f1f5f9',
  },
  specLabel: {
    fontSize: '0.875rem',
    color: '#64748b',
    fontWeight: '500',
  },
  specValue: {
    fontSize: '0.875rem',
    color: '#1e293b',
    fontWeight: '500',
  },
  quickInfoGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  quickInfoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
  },
  quickInfoIcon: {
    color: '#3b82f6',
    fontSize: '1.5rem',
    margin: 0,
  },
  quickInfoLabel: {
    fontSize: '0.75rem',
    color: '#64748b',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  quickInfoValue: {
    fontSize: '0.875rem',
    color: '#1e293b',
    fontWeight: '600',
    marginTop: '2px',
  },
  networkInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  networkItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '16px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
  },
  networkIcon: {
    color: '#3b82f6',
    fontSize: '1.5rem',
    margin: 0,
  },
  networkDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  networkLabel: {
    fontSize: '0.75rem',
    color: '#64748b',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  networkValue: {
    fontSize: '1rem',
    color: '#1e293b',
    fontWeight: '600',
    fontFamily: 'monospace',
  },
  locationInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  locationItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
  },
  locationIcon: {
    color: '#3b82f6',
    fontSize: '1.25rem',
    margin: 0,
  },
  locationLabel: {
    fontSize: '0.75rem',
    color: '#64748b',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  locationValue: {
    fontSize: '0.875rem',
    color: '#1e293b',
    fontWeight: '600',
    marginTop: '2px',
  },
  notesCard: {
    backgroundColor: '#eff6ff',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #dbeafe',
    marginBottom: '20px',
  },
  notesContent: {
    padding: '4px 0',
  },
  notesText: {
    fontSize: '0.9375rem',
    lineHeight: '1.7',
    color: '#1e40af',
    margin: 0,
  },
  metadataCard: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #e2e8f0',
  },
  metadataSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  metadataItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '12px 0',
    borderBottom: '1px solid #f1f5f9',
  },
  metadataLabel: {
    fontSize: '0.75rem',
    color: '#64748b',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  metadataValue: {
    fontSize: '0.875rem',
    color: '#1e293b',
    fontWeight: '500',
  },
  naText: {
    color: '#94a3b8',
    fontStyle: 'italic',
  },
  productLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    textDecoration: 'none',
    color: '#3b82f6',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
  },
  linkIcon: {
    margin: 0,
    fontSize: '0.875rem',
    opacity: 0.7,
  },
  familyContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  servicePortsSection: {
    marginTop: '16px',
    padding: '16px',
    backgroundColor: '#f8fafc',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
  },
  servicePortsHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px',
  },
  servicePortsIcon: {
    color: '#3b82f6',
    margin: 0,
  },
  servicePortsTitle: {
    fontSize: '0.875rem',
    color: '#374151',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  servicePortsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '12px',
  },
  servicePortItem: {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '12px',
    border: '1px solid #e5e7eb',
    transition: 'all 0.2s ease',
  },
  servicePortContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  serviceName: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
  },
  serviceIcon: {
    color: '#6b7280',
    fontSize: '0.875rem',
    margin: 0,
  },
  serviceText: {
    fontSize: '0.875rem',
    color: '#374151',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.025em',
  },
  portBadge: {
    flexShrink: 0,
  },
  portLabel: {
    margin: 0,
    fontSize: '0.75rem',
    fontWeight: '600',
  },
  noPorts: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '16px',
    backgroundColor: '#f9fafb',
    borderRadius: '6px',
    border: '1px dashed #d1d5db',
  },
  noPortsIcon: {
    color: '#9ca3af',
    margin: 0,
  },
  noPortsText: {
    fontSize: '0.875rem',
    color: '#6b7280',
    fontStyle: 'italic',
  },
  additionalSpecsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  additionalSpecItem: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '12px',
    backgroundColor: '#fafafa',
  },
  additionalSpecContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  additionalSpecName: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  additionalSpecIcon: {
    color: '#666',
    fontSize: '14px',
  },
  additionalSpecText: {
    fontWeight: '500',
    color: '#333',
  },
  additionalSpecValue: {
    backgroundColor: 'white',
    padding: '4px 12px',
    borderRadius: '6px',
    border: '1px solid #e0e0e0',
  },
  additionalSpecValueText: {
    fontWeight: '600',
    color: '#2c5aa0',
  },
  noSpecs: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    border: '2px dashed #dee2e6',
    color: '#6c757d',
  },
  noSpecsIcon: {
    marginRight: '8px',
  },
  noSpecsText: {
    fontSize: '14px',
    fontStyle: 'italic',
  },
  rackCard: {
    marginTop: 16,
    paddingTop: 16,
    borderTop: '1px solid #e8e8e8',
  },
  rackHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12,
  },
  rackIcon: {
    fontSize: 18,
    color: '#1890ff',
  },
  rackTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: '#262626',
  },
  rackContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  rackInfoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  rackInfoIcon: {
    fontSize: 16,
    color: '#8c8c8c',
    width: 20,
  },
  rackInfoLabel: {
    fontSize: 12,
    color: '#8c8c8c',
    marginBottom: 2,
  },
  rackLink: {
    color: '#1890ff',
    fontSize: 14,
    fontWeight: 500,
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    transition: 'color 0.2s',
    '&:hover': {
      color: '#40a9ff',
      textDecoration: 'underline',
    },
  },
  rackLinkIcon: {
    fontSize: 12,
  },
  rackUnitText: {
    fontSize: 14,
    color: '#262626',
    fontWeight: 500,
  },
};